export default __webpack_public_path__ + "static/media/accountBanner.bd258350.png";